// user_information.js - Fix the export
import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialState = {
    loginData: Cookies.get('influencerData') ? JSON.parse(Cookies.get('influencerData')) : null,
    token: Cookies.get('influencerToken') ? Cookies.get('influencerToken') : null,
    isLoading: false,
    error: null
}

const influencerSlice = createSlice({
    name: "influencer",
    initialState,
    reducers: {
        setLoginData(state, action) {
            state.loginData = action.payload.influencer;
            state.token = action.payload.token;
            Cookies.set('influencerData', JSON.stringify(action.payload.influencer));
            Cookies.set('influencerToken', action.payload.token);
            console.log("Influencer login payload:", action.payload);
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        },
        setError(state, action) {
            state.error = action.payload;
        },
        logout(state) {
            state.loginData = null;
            state.token = null;
            state.error = null;
            Cookies.remove('influencerData');
            Cookies.remove('influencerToken');
        },
        updateProfileData(state, action) {
            if (state.loginData) {
                state.loginData = { ...state.loginData, ...action.payload };
                Cookies.set('influencerData', JSON.stringify(state.loginData));
            }
        }
    }
});

export const { setLoginData, setLoading, setError, logout, updateProfileData } = influencerSlice.actions;
export default influencerSlice.reducer; 